import { gql } from "apollo-boost";

export const GET_DESIGNS = (id_entity) => gql`
  query GET_DESIGNS {
    designs(id_entity: ${id_entity}) {
      id_design
      name
      date
      id_article {
        id_article
        name
        is_prototype
        date
        id_article_type {
          id_article_type
          name
        }
        in_use
      }
    }
  }
`;

export const GET_DESIGNS_ARTICLE = (id) => gql`
  query GET_DESIGNS_ARTICLE {
    designsArticle(id_article: ${id}) {
      id_design
      name
      date
      id_article {
        id_article
        name
        is_prototype
        date
        id_article_type {
          id_article_type
          name
        }
        in_use
      }
    }
  }
`;

export const GET_VALUES_DESIGN = (id) => gql`
  query GET_VALUES_DESIGN {
        valuesDesign(id_design: ${id}) {
          id_variable{
            id_variable
            name
          }
          value
        }
  }
`;
